import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as V } from "../hooks/useScalarIcon.js";
const f = { key: 0 }, h = { key: 1 }, k = { key: 2 }, w = { key: 3 }, A = { key: 4 }, L = { key: 5 }, M = {
  name: "ScalarIconArrowUp"
}, _ = /* @__PURE__ */ i({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = V(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(a) === "bold" ? (l(), o("g", f, t[0] || (t[0] = [
        n("path", { d: "M208.49,120.49a12,12,0,0,1-17,0L140,69V216a12,12,0,0,1-24,0V69L64.49,120.49a12,12,0,0,1-17-17l72-72a12,12,0,0,1,17,0l72,72A12,12,0,0,1,208.49,120.49Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (l(), o("g", h, t[1] || (t[1] = [
        n("path", {
          d: "M200,112H56l72-72Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M205.66,106.34l-72-72a8,8,0,0,0-11.32,0l-72,72A8,8,0,0,0,56,120h64v96a8,8,0,0,0,16,0V120h64a8,8,0,0,0,5.66-13.66ZM75.31,104,128,51.31,180.69,104Z" }, null, -1)
      ]))) : e(a) === "fill" ? (l(), o("g", k, t[2] || (t[2] = [
        n("path", { d: "M207.39,115.06A8,8,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8,8,0,0,1-5.66-13.66l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,207.39,115.06Z" }, null, -1)
      ]))) : e(a) === "light" ? (l(), o("g", w, t[3] || (t[3] = [
        n("path", { d: "M204.24,116.24a6,6,0,0,1-8.48,0L134,54.49V216a6,6,0,0,1-12,0V54.49L60.24,116.24a6,6,0,0,1-8.48-8.48l72-72a6,6,0,0,1,8.48,0l72,72A6,6,0,0,1,204.24,116.24Z" }, null, -1)
      ]))) : e(a) === "regular" ? (l(), o("g", A, t[4] || (t[4] = [
        n("path", { d: "M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z" }, null, -1)
      ]))) : e(a) === "thin" ? (l(), o("g", L, t[5] || (t[5] = [
        n("path", { d: "M202.83,114.83a4,4,0,0,1-5.66,0L132,49.66V216a4,4,0,0,1-8,0V49.66L58.83,114.83a4,4,0,0,1-5.66-5.66l72-72a4,4,0,0,1,5.66,0l72,72A4,4,0,0,1,202.83,114.83Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
